import Styles from './ImageGoogleButton.module.scss';

type Props = {
  onClick: () => unknown;
};

export const ImageGoogleButton = ({onClick}: Props) => {
  return <button className={Styles.googleButton} onClick={onClick} />;
};
